"use client";

import { useActionState } from "react";
import Link from "next/link";
import { AlertCircleIcon, LoaderCircleIcon } from "lucide-react";

import { loginAction } from "@/lib/auth/actions";
import type { ActionState } from "@/lib/api/types";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const initialState: ActionState = { ok: false };

export function SignInForm() {
  const [state, formAction, pending] = useActionState(loginAction, initialState);

  return (
    <form action={formAction} className="mt-8 space-y-6">
      {state.message ? (
        <Alert variant="destructive">
          <AlertCircleIcon />
          <AlertDescription>{state.message}</AlertDescription>
        </Alert>
      ) : null}

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="admin@horsink.com"
            aria-invalid={Boolean(state.errors?.email)}
          />
          {state.errors?.email ? (
            <p className="text-destructive text-sm">{state.errors.email}</p>
          ) : null}
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">Mot de passe</Label>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            placeholder="••••••••"
            aria-invalid={Boolean(state.errors?.password)}
          />
          {state.errors?.password ? (
            <p className="text-destructive text-sm">{state.errors.password}</p>
          ) : null}
        </div>

        <div className="text-end">
          <Link href="/dashboard/forgot-password" className="text-sm underline">
            Mot de passe oublié ?
          </Link>
        </div>
      </div>

      <Button type="submit" className="w-full" disabled={pending}>
        {pending ? <LoaderCircleIcon className="animate-spin" /> : null}
        Se connecter
      </Button>
    </form>
  );
}
